import { render } from "./CollectionSummary.vue?vue&type=template&id=4614623f&scoped=true&ts=true"
import script from "./CollectionSummary.vue?vue&type=script&lang=ts"
export * from "./CollectionSummary.vue?vue&type=script&lang=ts"

import "./CollectionSummary.vue?vue&type=style&index=0&id=4614623f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4614623f"]])

export default __exports__